import FullscreenIcon from '@material-ui/icons/Fullscreen'
import FullscreenExitIcon from '@material-ui/icons/FullscreenExit'
import { Form, Formik } from 'formik'
import { isEmpty } from 'lodash'
import React, { useEffect } from 'react'

import { createVisitor } from 'api'
import constants from 'app/constants'
import { eventAlert, showToast } from 'app/helpers'
import ohLogo from 'assets/images/openhouse_logo.png'
import WelcomeIcon from 'assets/images/welcome.svg'

import {
  fetchPurposeOfVisitOptions,
  fetchAttributionOptions,
  fetchAdmin
} from './helper'
import * as styles from './styles'
import VisitorEntryForm from './VisitorEntryForm'

const initialData = {
  parentName: '',
  parentNumber: '',
  childName: '',
  childDOB: '',
  purposeOfVisit: [],
  attribution: ''
}

// const userID = getLoggedInUserId()

const VisitorEntry = () => {
  const [, forceUpdate] = React.useReducer((x) => x + 1, 0)
  const [userError, setUserError] = React.useState(false)
  const [centre, setCentre] = React.useState(null)
  const [loadingSubmit, setLoadingSubmit] = React.useState(false)
  const [purposeOptions, setPurposeOptions] = React.useState([])
  const [attributionOptions, setAttributionOptions] = React.useState([])
  const [formData, setFormData] = React.useState(initialData)
  const [reload, setReload] = React.useState(false)
  const [isFullscreen, setIsFullscreen] = React.useState(false)
  const formRef = React.useRef(null)
  const buttonRef = React.useRef(null)

  function requestFullScreen() {
    if (
      (document.fullScreenElement && document.fullScreenElement !== null) ||
      (!document.mozFullScreen && !document.webkitIsFullScreen)
    ) {
      if (document.documentElement.requestFullScreen) {
        document.documentElement.requestFullScreen()
      } else if (document.documentElement.mozRequestFullScreen) {
        /* Firefox */
        document.documentElement.mozRequestFullScreen()
      } else if (document.documentElement.webkitRequestFullScreen) {
        /* Chrome, Safari & Opera */
        document.documentElement.webkitRequestFullScreen(
          Element.ALLOW_KEYBOARD_INPUT
        )
      } else if (document.msRequestFullscreen) {
        /* IE/Edge */
        document.documentElement.msRequestFullscreen()
      }
      setIsFullscreen(true)
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen()
      } else if (document.mozCancelFullScreen) {
        /* Firefox */
        document.mozCancelFullScreen()
      } else if (document.webkitCancelFullScreen) {
        /* Chrome, Safari and Opera */
        document.webkitCancelFullScreen()
      } else if (document.msExitFullscreen) {
        /* IE/Edge */
        document.msExitFullscreen()
      }
      setIsFullscreen(false)
    }
  }

  useEffect(() => {
    setReload(false)
    ;(async () => {
      await fetchAdmin(setUserError, setCentre)
      await fetchPurposeOfVisitOptions(setPurposeOptions)
      await fetchAttributionOptions(setAttributionOptions)
    })()
  }, [])

  useEffect(() => {
    if (reload) {
      forceUpdate()
    }
  }, [reload])

  // useEffect(async () => {
  //   ;(async () => {
  //     if (userID) {
  //       await fetchAdmin(userID, setUserError, setCentre)
  //     }
  //   })()
  // }, [userID])

  const OnSubmitClick = async (formData) => {
    const { submitForm, validateForm, values, resetForm } = formRef.current

    try {
      const errors = await validateForm({ ...values })

      if (!isEmpty(errors)) {
        // call submit form , it will ask to validate all fields
        submitForm()
        // emit event to enable save button again
        setLoadingSubmit(false)
      } else {
        const response = await createVisitor({ ...values, centre })

        if (response?.success) {
          showToast('registration sucessful', 'success')
          setLoadingSubmit(false)
          setFormData({ ...initialData })
          resetForm()
          return response
        }
      }
    } catch (error) {
      // eventAlert(error.message, constants.ERROR)
      throw error
    }
  }

  const handleOnSubmitClick = React.useCallback(async () => {
    setLoadingSubmit(true)
    try {
      const saved = await OnSubmitClick(formData)
    } catch (error) {
      console.log(error)
      eventAlert(error.message, constants.ERROR)
      setLoadingSubmit(false)
    }
  }, [OnSubmitClick])

  const userExistsFunction = () => {
    const { resetForm } = formRef.current
    setLoadingSubmit(false)
    setFormData({ ...initialData })
    setReload(true)
    resetForm()
  }

  const formElement = React.useMemo(() => {
    return (
      <Formik
        initialValues={formData}
        onSubmit={(values, { validate }) => {
          validate(values)
        }}
        validateOnChange={false}
        validateOnBlur={false}
        innerRef={formRef}
      >
        {() => {
          return (
            <Form>
              <VisitorEntryForm
                formData={formData}
                loadingSubmit={loadingSubmit}
                handleOnSubmitClick={handleOnSubmitClick}
                purposeOptions={purposeOptions}
                attributionOptions={attributionOptions}
                userExistsFunction={userExistsFunction}
              />
            </Form>
          )
        }}
      </Formik>
    )
  }, [formData, loadingSubmit, attributionOptions, purposeOptions])

  return (
    <styles.Container>
      <styles.Button
        ref={buttonRef}
        aria-label="fullscreen"
        onClick={requestFullScreen}
      >
        {isFullscreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
      </styles.Button>
      <styles.LeftContainer>
        <styles.OhLogo src={ohLogo} alt="oh logo" />
        <styles.CoverImage src={WelcomeIcon} alt="welcome to oh." />
      </styles.LeftContainer>
      <styles.RightContainer>
        <styles.FormContainer>
          {userError ? (
            'account not mapped to any centre'
          ) : (
            <styles.Form>
              <styles.Header>
                <styles.FormTitle variant="h5" component="h3">
                  visitor entry form
                </styles.FormTitle>
                <styles.FormSubTitle variant="subtitle1">
                  oh. hello! A few quick details will help us make your first
                  visit smooth and personal
                </styles.FormSubTitle>
              </styles.Header>
              {formElement}
            </styles.Form>
          )}
        </styles.FormContainer>
      </styles.RightContainer>
    </styles.Container>
  )
}

export default VisitorEntry
